import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import LayoutHeader from "../components/layoutHeader";
import { logout } from "../actions/user";
import { changeGeneralStoreSettings, closeAragUserSettingsMenu, openAragUserSettingsMenu } from "../actions/general";

const UserHeaderHOC = () => {
    const dispatch = useDispatch();

    const isSettingsMenuOpen = useSelector(state => state.general.isSettingsMenuOpen);
    const locationPathName = useSelector(state => state.router.location.pathname);
    const userData = useSelector(state => state.user.loggedInUser);
    const notificationsIconCount = useSelector(state => state.notifications.notificationsIconCount);
    const [isNavbarOpen, setIsNavbarOpen] = useState(false);

    // Destructure user data with default values
    const {
        username,
        forename,
        roles: userRoles,
        allowedToEditOtherApplications = false,
        allowedToEditPremiumSettings = false,
        allowedToEditReferralSettings = false,
        allowedToEditTobas = false,
        allowedToEditArticles = false,
        allowedToEditEditingSettings = false,
        allowedToCreateInternalAlerts = false
    } = userData;

    // Action handlers
    const handlePush = (url) => dispatch(push(url));
    const handleLogout = () => dispatch(logout());
    const handleChangeStoreSettings = (payload) => dispatch(changeGeneralStoreSettings(payload));
    const handleOpenAragUserSettingsMenu = (payload) => dispatch(openAragUserSettingsMenu(payload));
    const handleCloseAragUserSettingsMenu = (payload) => dispatch(closeAragUserSettingsMenu(payload));

    const handleSettingsMenuClick = () => {
        handleChangeStoreSettings({
            key: 'isSettingsMenuOpen',
            value: !isSettingsMenuOpen
        });
    };

    return (
        <LayoutHeader
            logout={handleLogout}
            push={handlePush}
            username={username}
            forename={forename}
            userRoles={userRoles}
            locationPathName={locationPathName}
            notificationsIconCount={notificationsIconCount}
            allowedToEditPremiumSettings={allowedToEditPremiumSettings}
            allowedToEditReferralSettings={allowedToEditReferralSettings}
            allowedToEditTobas={allowedToEditTobas}
            allowedToEditArticles={allowedToEditArticles}
            allowedToEditEditingSettings={allowedToEditEditingSettings}
            allowedToEditOtherApplications={allowedToEditOtherApplications}
            allowedToCreateInternalAlerts={allowedToCreateInternalAlerts}
            _handleSettingsMenuClick={handleSettingsMenuClick}
            isSettingsMenuOpen={isSettingsMenuOpen}
            openAragUserSettingsMenu={handleOpenAragUserSettingsMenu}
            closeAragUserSettingsMenu={handleCloseAragUserSettingsMenu}
            isNavbarOpen={isNavbarOpen}
            setIsNavbarOpen={setIsNavbarOpen}
        />
    );
};

export default UserHeaderHOC;